import {
  minValue,
  momentToDateTimeFormat,
  parseDate,
  parseDateExpression,
  parseISODate,
  toDateTimeTypeString,
} from "DateExtensions";
import { DateTimeType } from "DateTimeConstants";
import { type TimeInfo } from "LocaleSettings";
import { type DateTimeFormat, type DateTimeFormatter as wtgMaterialDateTimeFormatter } from "wtg-material-ui";

export default class DateTimeFormatter implements wtgMaterialDateTimeFormatter {
  readonly timeInfo: TimeInfo;

  constructor(timeInfo: TimeInfo) {
    this.timeInfo = timeInfo;
  }

  format(isoDateTime: string, _useSeconds: boolean, dateTimeIsLocal?: boolean): string {
    let result = isoDateTime;
    if (isoDateTime) {
      const momentValue = dateTimeIsLocal
        ? parseISODate(isoDateTime, DateTimeType.DateTime)
        : parseISODate(isoDateTime, DateTimeType.DateTimeUtc, this.getTimeZone());

      if (momentValue.isValid() && !minValue().isAfter(momentValue)) {
        result = minValue().isSame(momentValue) ? "" : toDateTimeTypeString(momentValue, DateTimeType.DateTime);
      }
    }
    return result;
  }

  parse(date: string): string | null {
    if (date === "") {
      return "";
    }

    let result = null;
    if (date) {
      const value = date;
      let momentValue = parseDateExpression(
        value,
        DateTimeType.DateTime,
        this.getTimeZone(),
        this.timeInfo.dateTimeFormatConfig,
      );

      if (!momentValue.isValid()) {
        momentValue = parseDate(value, DateTimeType.DateTime, this.getTimeZone(), this.timeInfo.dateTimeFormatConfig);
      }

      if (momentValue.isValid() && !minValue().isAfter(momentValue)) {
        result = momentValue.toISOString();
      }
    }
    return result;
  }

  private getTimeZone(): string {
    return this.timeInfo.defaultTimeZone ?? "";
  }

  values(isoString: string): DateTimeFormat {
    const momentValue = parseDate(isoString, DateTimeType.DateTimeUtc, this.getTimeZone());
    return momentToDateTimeFormat(momentValue);
  }
}
